document.addEventListener('click', function (e) {
  if (
    !e.target.closest('[js-tooltip-body]') &&
    !e.target.closest('[js-tooltip-trigger]')
  ) {
    document.querySelector('[js-tooltip-body].open')?.classList.remove('open');
  }
});

if (!customElements.get('product-table-tooltip')) {
  class ProductTableTooltip extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.trigger = this.querySelector('[js-tooltip-trigger]');
      this.body = this.querySelector('[js-tooltip-body]');

      this.trigger.addEventListener('click', this.onTriggerClick.bind(this));
    }

    onTriggerClick() {
      document
        .querySelector('[js-tooltip-body].open')
        ?.classList.remove('open');
      this.body.classList.add('open');
    }
  }
  customElements.define('product-table-tooltip', ProductTableTooltip);
}
